import { render, staticRenderFns } from "./GroupDistributePhone.vue?vue&type=template&id=5fa38800&scoped=true&"
import script from "./GroupDistributePhone.vue?vue&type=script&lang=js&"
export * from "./GroupDistributePhone.vue?vue&type=script&lang=js&"
import style0 from "./GroupDistributePhone.vue?vue&type=style&index=0&id=5fa38800&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa38800",
  null
  
)

export default component.exports